import { Modal } from '@trackman/web-shared-components';
import { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Input } from '@trackman/web-shared-components';
import { useStores } from 'index';

type Props = {
  open: boolean;
  onClose: () => void;
};

export const CreateFolderDialog = observer(({ open, onClose }: Props) => {
  const [name, setName] = useState('');

  const fileManagerStore = useStores().mediaLibraryStore;

  const handleClose = () => {
    setName('');
    onClose();
  };

  const handleCreate = async () => {
    const trimmed = name.trim();
    if (trimmed) {
      await fileManagerStore.createFolder(trimmed);
      handleClose();
    }
  };

  return (
    <Modal
      className="admin-modal"
      open={open}
      title="Create New Folder"
      cancelBtn={{
        label: 'Cancel',
        onClick: handleClose,
      }}
      confirmBtn={{
        label: 'Create',
        onClick: handleCreate,
        disabled: !name.trim(),
      }}
      onClose={handleClose}
    >
      <div className="modal-body">
        <Input
          autoFocus
          label="Folder name"
          placeholder="Enter folder name"
          value={name}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              handleCreate();
            }
          }}
        />
      </div>
    </Modal>
  );
});
